import { computed } from "vue"
import { mapState } from "vuex"

export default function usePriceCount() {
  const filters = mapState("filter", {
    prices: ({ filters }) => filters.prices,
    priceRange: ({ filters }) => filters.price_range,
    artist_discount_filter_preference: ({ filters }) => filters.artist_discount_filter_preference,
    framing_filter_preference: ({ filters }) => filters.framing_filter_preference,
  })

  const priceRange = computed(filters.priceRange)
  const artist_discount_filter_preference = computed(filters.artist_discount_filter_preference)
  const framing_filter_preference = computed(filters.framing_filter_preference)
  const prices = computed(filters.prices)

  const customPriceRange = computed(() => {
    return priceRange.value[0] ? `$${priceRange.value[0]}-${priceRange.value[1]}` : null
  })

  const count = computed(
    () =>
      prices.value.length +
      (customPriceRange.value != null ? 1 : 0) +
      (artist_discount_filter_preference.value ? 1 : 0) +
      (framing_filter_preference.value ? 1 : 0),
  )

  return computed(() => ({
    badgeContent: count.value,
    badgeCondition: count.value > 0,
  }))
}
